<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <img src="assets/loading.svg">
        <span class="loading-message">Cargando...</span>
    </div>
</div>